/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useContext } from "react";

type CubeJsApiContextType = {
  cubejsApi: any;
  setCubejsApi: (api: any) => void;
} | null;

const CubeJsApiContext = createContext<CubeJsApiContextType>(null);

type CubeJsApiProviderProps = {
  children: React.ReactNode;
  cubejsApi: any;
  setCubejsApi: (api: any) => void;
};

export const CubeJsApiProvider = ({
  children,
  cubejsApi,
  setCubejsApi,
}: CubeJsApiProviderProps) => (
  <CubeJsApiContext.Provider value={{ cubejsApi, setCubejsApi }}>
    {children}
  </CubeJsApiContext.Provider>
);

export const useCubeJsApi = () => {
  const cubejsApi = useContext(CubeJsApiContext);
  if (!cubejsApi) {
    throw new Error("useCubeJsApi must be used within a CubeJsApiProvider");
  }
  return cubejsApi;
};
